module.exports = __webpack_public_path__ + "img/division_menu.3c945681.png";